<template>
  <NavBar pageName="Settings"></NavBar>
  <v-container style="margin-top: 185px;">
    <h2 class="mb-4">Settings</h2>

    <!-- Section Cards -->
    <v-row>
      <v-col v-for="section in filteredSections" :key="section.slug" cols="12" sm="6" md="4" lg="3">
        <v-card
          variant="outlined"
          class="pa-4 text-center cursor-pointer section-card"
          @click="$router.push(section.route)"
          hover
        >
          <v-icon size="36" class="mb-2" color="primary">{{ section.icon }}</v-icon>
          <div class="text-subtitle-1 font-weight-medium">{{ section.title }}</div>
          <div class="text-caption text-grey" v-if="section.count">{{ section.count }} settings</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
import store from "@/store";

// Components

export default defineComponent({
  name: 'SettingsList',
  components: {
    NavBar
  },
  data() {
    return {
      showToken:false,
      token:'',
      clientsListLoaded:false,
      userRoles: [],
      settingsSections: [
        { title: 'IMSI', slug: 'imsi', icon: 'mdi-sim', count: 3, route: '/settings/imsi', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin'] },
        { title: 'SIM', slug: 'sim', icon: 'mdi-cellphone-link', count: 0, route: '/settings/sim', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin'] },
        { title: 'MSISDN', slug: 'msisdn', icon: 'mdi-phone-classic', count: 3, route: '/settings/msisdn', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin'] },
        { title: 'Services', slug: 'services', icon: 'mdi-cogs', count: 5, route: '/settings/services', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin'] },
        { title: 'Client Services', slug: 'client-services', icon: 'mdi-account-cog', count: 2, route: '/settings/client-services', roles: ['root', 'admin', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'Goods', slug: 'goods', icon: 'mdi-package-variant', count: 2, route: '/settings/goods', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'Inventory', slug: 'inventory', icon: 'mdi-warehouse', count: 1, route: '/settings/inventory', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'Templates', slug: 'templates', icon: 'mdi-view-dashboard-outline', count: 1, route: '/settings/templates', roles: ['root', 'admin', 'super_admin'] },
        { title: 'Notifications', slug: 'notifications', icon: 'mdi-bell-outline', count: 1, route: '/settings/notifications', roles: ['root', 'admin'] },
        { title: 'DashBoard', slug: 'dashboard', icon: 'mdi-view-dashboard', route: '/', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'Delivery Prices', slug: 'delivery', icon: 'mdi-truck-delivery', route: '/deliveryPricesSettings', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin'] },
        { title: 'EUR/RON Rates', slug: 'eurron', icon: 'mdi-currency-eur', route: '/euroRonRatesSettings', roles: ['root', 'admin', 'general', 'super_admin'] },
        { title: 'Roles', slug: 'roles', icon: 'mdi-shield-account', route: '/rolesSettings', roles: ['root', 'admin', 'general', 'super_admin'] },
        { title: 'Todos', slug: 'todos', icon: 'mdi-clipboard-check-outline', route: '/todosSettings', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'User Preferences', slug: 'preferences', icon: 'mdi-cog-outline', route: '/userPreferencesSettings', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
        { title: 'Settings Parameters', slug: 'parameters', icon: 'mdi-cog-transfer', route: '/settingsParameters', roles: ['root', 'admin'] },
        { title: 'Display Settings', slug: 'display', icon: 'mdi-monitor-eye', route: '/settings/display', roles: ['root'] },
        { title: 'GDPR Search', slug: 'gdpr-search', icon: 'mdi-shield-search', route: '/settings/gdpr-search', roles: ['root'] },
        { title: 'Administrator', slug: 'admin', icon: 'mdi-shield-crown', count: 1, route: '/settings/admin', roles: ['root', 'default_admin_l0'] },
        { title: 'Host Access Control', slug: 'host-access', icon: 'mdi-shield-lock-outline', route: '/hostAccessControl', roles: ['root', 'devops'] },
        { title: 'Translations', slug: 'translations', icon: 'mdi-translate', route: '/translations', roles: ['root', 'admin', 'manage_translations'] },
        { title: 'HowTo Guides', slug: 'howto', icon: 'mdi-book-open-variant', route: '/howto', roles: ['root', 'admin', 'general', 'manager_sectiune', 'super_admin', 'distributor', 'default_admin_l0', 'standard_admin_l0'] },
      ],
    }
  },
  computed: {
    filteredSections() {
      if (this.userRoles.length === 0 && this.token) {
        return this.settingsSections;
      }
      return this.settingsSections.filter(section => {
        if (section.roles && section.roles.length > 0) {
          return section.roles.some(role => this.userRoles.includes(role));
        }
        return true;
      });
    },
    filteredSettingsLinks() {
      return [];
    }
  },
  methods: {
    showClientsList() {
      this.clientsListLoaded=true
    }
  },
  created() {
    const {getLoggedIn, user, loggedIn}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      log ("dupa created in SettingsList avem:")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      this.token=store.getters.getToken
      // Get user roles from store or user object
      const currentUser = store.getters.getUser;
      log("currentUser from store:");
      log(currentUser);

      log("DEBUG - currentUser.roles:", currentUser?.roles);
      log("DEBUG - typeof currentUser.roles:", typeof currentUser?.roles);

      if (currentUser && currentUser.roles && Array.isArray(currentUser.roles) && currentUser.roles.length > 0) {
        this.userRoles = currentUser.roles.map(r => {
          if (typeof r === 'string') return r;
          if (r && r.name) return r.name;
          if (r && r.role_name) return r.role_name;
          return String(r);
        });
      } else if (currentUser && currentUser.user_roles && Array.isArray(currentUser.user_roles)) {
        // Try user_roles array
        this.userRoles = currentUser.user_roles.map(r => {
          if (typeof r === 'string') return r;
          if (r && r.name) return r.name;
          if (r && r.role_name) return r.role_name;
          if (r && r.role && r.role.name) return r.role.name;
          return String(r);
        });
      } else if (currentUser && currentUser.role) {
        this.userRoles = [currentUser.role];
      } else if (currentUser && currentUser.role_name) {
        this.userRoles = [currentUser.role_name];
      } else {
        // Fallback: if user is logged in but no roles found, give them basic access
        this.userRoles = ['general'];
        log("No roles found, using fallback 'general' role");
      }
      log("userRoles FINAL: " + JSON.stringify(this.userRoles));
      log("filteredSections count: " + this.filteredSections.length);
    })
  }
});
</script>

<style scoped>
.section-card {
  transition: all 0.2s ease;
}
.section-card:hover {
  border-color: rgb(var(--v-theme-primary));
  background-color: rgba(var(--v-theme-primary), 0.04);
}
.cursor-pointer {
  cursor: pointer;
}
</style>
